<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content" style="width: 100%">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('newBatch') }}</h5>
                    <button type="button" class="btn-close" @click="$emit('cancel')"></button>
                </div>
                <div class="modal-body">
                    <label class="form-label fw-bold small text-uppercase">{{ $t('batchName') }}</label>
                    <input v-model="name" class="form-control mb-4" :placeholder="$t('batchNamePlaceholder')" />

                    <label class="form-label fw-bold small text-uppercase">{{ $t('dataLoadMethod') }}</label>
                    <div class="type-cards">
                        <div :class="['type-card', { selected: batchType === 'Copy' }]" @click="batchType = 'Copy'">
                            <i class="fas fa-copy"></i>
                            <strong>{{ $t('typeCopy') }}</strong>
                            <small>{{ $t('typeCopyDesc') }}</small>
                        </div>
                        <div :class="['type-card', { selected: batchType === 'Aggregation' }]" @click="batchType = 'Aggregation'">
                            <i class="fas fa-layer-group"></i>
                            <strong>{{ $t('typeAggregation') }}</strong>
                            <small>{{ $t('typeAggregationDesc') }}</small>
                        </div>
                        <div :class="['type-card', { selected: batchType === 'CSD' }]" @click="batchType = 'CSD'">
                            <i class="fas fa-code-branch"></i>
                            <strong>Common Smallest Denominator</strong>
                            <small>{{ $t('typeCsdDesc') }}</small>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" @click="$emit('cancel')">
                        {{ $t('cancel') }}
                    </button>
                    <button class="btn btn-primary" @click="create" :disabled="!canCreate || saving">
                        {{ $t('createBatch') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>

<script>
import DataBatchApi from '../../api/server/databatch';

export default {
    name: 'DataBatchForm',
    data() {
        return {
            name: '',
            batchType: '',
            saving: false
        };
    },
    computed: {
        dataSpaceId() {
            return this.$route.params.id;
        },
        canCreate() {
            return this.name && this.batchType;
        }
    },
    methods: {
        async create() {
            this.saving = true;
            
            var result = await DataBatchApi.dataBatchCreate(this.dataSpaceId, {
                name: this.name,
                batchType: this.batchType
            });
            this.$router.push(`/dataspace/${this.dataSpaceId}/batches/${result.id}`);
    
            this.saving = false;
        }
    }
};
</script>